import { useParams } from 'react-router-dom'

import { useOperatorGetApi } from '@/common/api/modules/operator'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import OperatorEditPage from '@/components/container/page/admin/operator/OperatorEditPage'

const OperatorUpdatePage = () => {
  const { operatorId } = useParams()

  const { data, error, mutate } = useOperatorGetApi({
    operator_id: Number(operatorId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <OperatorEditPage operator={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default OperatorUpdatePage
